<ion-item [ngClass]="color ? color : 'primary'" lines="none">
    <ion-icon *ngIf="icon" [slot]="slot" [name]="icon"></ion-icon>
    <ion-label *ngIf="title">
        {{title}}
        <span *ngIf="subtitle" class="small"><br/>{{subtitle}}</span>
    </ion-label>
</ion-item>